
import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  // baseURL: process.env.REACT_APP_BASE_URL,
  baseURL: process.env.REACT_APP_FIRSTBANK_BASEURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Frame-Options": "DENY",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Token"] = token;
    }
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    Promise.reject(error)
  }
);

export default instance;


